<tt-page>
    <tt-page-heading ttModel="p2_m_dodataimp" ttTranslate></tt-page-heading>
    <tt-do-data-imp [params]="params"></tt-do-data-imp>
</tt-page>
